<script lang="ts">
export interface RoleBadgeProps {
  role: "owner" | "member"
}
</script>

<script setup lang="ts">
withDefaults(defineProps<RoleBadgeProps>(), {})
</script>

<template>
  <UBadge :color="role === 'owner' ? 'primary' : 'neutral'" variant="subtle">
    {{ role === "owner" ? "Owner" : "Member" }}
  </UBadge>
</template>
